(() => {
  const resourceSelector =
    '.rtd-course-selector__sample-link, .rtd-product-info-drawer__item-sample-link, .rtd-free-resources__resources-content a';
  const fileExtension = /\.(pdf|docx?|xlsx?|pptx?|csv|zip)$/i;

  function updateLink(link) {
    const href = link.getAttribute('href')?.trim();
    if (!href || href.startsWith('#')) return;

    let url;
    try {
      url = new URL(href, document.baseURI);
    } catch {
      return;
    }

    if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
    if (
      url.origin === window.location.origin &&
      !link.matches(resourceSelector) &&
      !link.hasAttribute('download') &&
      !fileExtension.test(url.pathname)
    ) return;

    link.target = '_blank';
    link.relList.add('noopener');

    const describedBy = new Set((link.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
    describedBy.add('a11y-new-window-message');
    link.setAttribute('aria-describedby', [...describedBy].join(' '));
  }

  function updateLinks(root) {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  }

  updateLinks(document);

  // Course details and Theme Editor sections can be inserted after page load.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) updateLinks(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
